import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import star from 'four-nets/icons/svg/icon_star-full.svg';
import starTransparent from 'four-nets/icons/svg/icon_star-outlined.svg';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import defaultStyles from './stars-input-view.scss';

@Styled(defaultStyles)
@observer
class StarsInputView extends React.Component {
    @observable currentValue = 0;

    @action changeValue = value => {
        this.currentValue = value;
    };

    onChange = value => event => {
        event.preventDefault();
        if (this.props.onChange) {
            // to use with form.field.get(...).data.onChange
            const fakeEvent = { target: { value } };
            this.props.onChange(fakeEvent);
        }
        this.changeValue(value);
    };

    render() {
        const { id, styles } = this.props;
        const starValues = [1, 2, 3, 4, 5];

        const classNames = [styles.button];
        if (this.currentValue === 5) {
            classNames.push(styles.all);
        } else if (this.currentValue === 1) {
            classNames.push(styles.one);
        }

        return (
            <div className={styles.starsInput}>
                {starValues.map(value => (
                    <button
                        id={id}
                        key={`button_${value}`}
                        onClick={this.onChange(value)}
                        className={classNames.join(' ')}
                    >
                        <SVGIcon
                            style={{ image: styles.star }}
                            src={this.currentValue >= value ? star : starTransparent}
                            key={`star_${value}`}
                        />
                    </button>
                ))}
            </div>
        );
    }
}

export default StarsInputView;
